<h1 mat-dialog-title>{{ "businessUnitAdd.title" | translate }}</h1>
<form (ngSubmit)="save()" [formGroup]="form">
  <div mat-dialog-content>
    <mat-form-field>
      <input
        tabindex="1"
        formControlName="name"
        matInput
        name="name"
        placeholder="{{ 'businessUnitAdd.name' | translate }}"
      />
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-button tabindex="2" type="submit">
      {{ "businessUnitAdd.save" | translate }}
    </button>
    <button mat-button tabindex="3" (click)="cancel()" type="button">
      {{ "businessUnitAdd.cancel" | translate }}
    </button>
  </div>
</form>
